import React, {useEffect, useState} from 'react';
import { useHistory } from 'react-router';

import { notify } from '../../utils/utils';
import button from './images/button.svg';
import buySell from './images/buy-sell.svg';
import favorites from './images/favorites.svg';
import heatMap from './images/heat-map.svg';
import myPortfolio from './images/my-portfolio.svg';
import nftEns from './images/nft-ens.svg';
import reminders from './images/reminders.svg';
import statisticsFees from './images/statistics-fees.svg';
import walletscan from './images/walletscan.svg';
import whales from './images/whales.svg';

import './DashboardMainLink.scss';

interface DashboardMainLinkProps {
  name: string;
  image: string;
  link: string;
  active?: boolean;
  disabled?: boolean;
  id?: string;
  reverse: boolean;
  longText: boolean;
  demoMode?: boolean;
}

export interface IconContainer {
  [key: string]: any;
}

export const Icons: IconContainer = {
  myPortfolio,
  reminders,
  buySell,
  favorites,
  heatMap,
  nftEns,
  statisticsFees,
  whales,
  button,
  walletscan,
};


export function DashboardMainLink(props: DashboardMainLinkProps) {
  const history = useHistory();
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('light') ? 'light' : 'dark';
      setTheme(newTheme);
    };
  
    handleThemeChange();
  
    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);
  
    return () => {
      observer.disconnect();
    };
  }, []);
  const changeRoute = (link: string) => {
    if (!props.demoMode) {
      if (!props.disabled) history.push({ pathname: link, state: { prevPath: location.pathname } });
      else {
        if (link === '/coming-soon') notify(`${props.name} coming soon.`);
        else notify(`You should only see your connected wallet's ${props.name} section.`);
      }
    }
  };

  return (
    <div
      className={`dashboard-main-link-name-${theme} d-flex flex-direction-column align-items-between ${
        props.active ? 'active' : ''
      } ${props.disabled ? 'disabled' : ''} ${props.reverse ? 'r' : ''} ${
        props.longText ? 'long' : ''
      }`}
      onClick={() => changeRoute(props.link)}
      id={props.id}
    >
      <div
        className={`image-container`}
        style={{ backgroundImage: `url('./images/${props.image}')` }}
      />
      <div className="name sh-regular">{props.name}</div>
    </div>
  );
}
